(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-tabs"] && !Shopify.designMode) return;
  try {
    
  function initializePdtV2Section(sectionId, wrapperElement) {
    const tabButtons = wrapperElement.querySelectorAll(`.pdt-v2-tab-button-${sectionId}`);
    tabButtons.forEach(button => {
      button.addEventListener('click', function(event) {
        const tabIdToOpen = this.getAttribute('data-tab-target');
        openPdtV2Tab(this, tabIdToOpen, sectionId, wrapperElement);
      });
    });

    const faqButtons = wrapperElement.querySelectorAll('.pdt-v2-faq-question-button');
    faqButtons.forEach(button => {
      button.addEventListener('click', function() {
        togglePdtV2FAQ(this);
      });
    });

    // Initialize the first tab as active
    const firstTabButton = wrapperElement.querySelector(`.pdt-v2-tab-button-${sectionId}`);
    if (firstTabButton) {
      const firstTabId = firstTabButton.getAttribute('data-tab-target');
      openPdtV2Tab(firstTabButton, firstTabId, sectionId, wrapperElement); // Pass firstTabButton as the clicked element
    }
  }

  function openPdtV2Tab(clickedButton, tabIdToOpen, sectionId, wrapper) {
    if (!wrapper) return;

    const tabContents = wrapper.querySelectorAll(`.pdt-v2-tab-content-${sectionId}`);
    tabContents.forEach(tc => {
      tc.classList.remove('pdt-v2-active');
    });

    const tabButtons = wrapper.querySelectorAll(`.pdt-v2-tab-button-${sectionId}`);
    tabButtons.forEach(btn => {
      btn.classList.remove('pdt-v2-active');
    });

    if (clickedButton) {
      clickedButton.classList.add('pdt-v2-active');
    }

    const targetContent = wrapper.querySelector(`#${tabIdToOpen}`);
    if (targetContent) {
      targetContent.classList.add('pdt-v2-active');
    }
  }

  function togglePdtV2FAQ(buttonElement) {
    const answer = buttonElement.nextElementSibling;
    if (!answer || !answer.classList.contains('pdt-v2-faq-answer')) return;

    buttonElement.classList.toggle('pdt-v2-active');
    answer.classList.toggle('pdt-v2-active');
  }

  // Handles section loading in Theme Editor and on page load
  function _initPdtV2Section(sectionElement) {
    const sectionId = sectionElement.dataset.sectionId;
    if (sectionId) {
      initializePdtV2Section(sectionId, sectionElement);
    }
  }

  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.matches('.product-tabs-v2-wrapper')) {
       _initPdtV2Section(event.target);
    }
  });

  if (!window.Shopify.designMode) {
    document.addEventListener('DOMContentLoaded', function() {
      document.querySelectorAll('.product-tabs-v2-wrapper').forEach(sectionElement => {
        _initPdtV2Section(sectionElement);
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
